import { InjectionToken } from '@angular/core';

import { ComponentType } from '@recruitee/cdk/overlay';

export const ManageSchedulerLinkDialogComponentToken = new InjectionToken<ComponentType<any>>(
  'ManageSchedulerLinkDialogComponent',
);
